import React from 'react'
import { CBreadcrumb, CBreadcrumbItem } from '@coreui/react'
import { CallCenter } from './CallCenter'

import { useState } from 'react'
import ModifyPatientMap from '../../services/general/modifyPatientMap.api'
import { Questions2 } from './Questions2'

export const CallCenterParent = () => {
  const [show, SetShow] = useState(true)
  const [patientData, setPatientData] = useState({})
  const patientName = [patientData?.FirstName, patientData?.MiddleName, patientData?.LastName].filter(Boolean).join(' ')

  const handlePatientClick = (e) => {
    SetShow(false)
    setPatientData(e)
  }

  const handleBackToPatients = () => {
    SetShow(true)
  }

  const handleSaveQuestions = async (e) => {
    await ModifyPatientMap('UPDATE', patientData.PatientID, e)

    SetShow(true)
  }

  return (
    <>
      {show ? (
        <CallCenter patientClick={handlePatientClick}></CallCenter>
      ) : (
        <>
          <CBreadcrumb className="mb-3">
            <CBreadcrumbItem>
              <button type="button" className="call-center-breadcrumb-button" onClick={handleBackToPatients}>
                Call Center Patients
              </button>
            </CBreadcrumbItem>
            <CBreadcrumbItem active>{patientName || 'Patient Details'}</CBreadcrumbItem>
          </CBreadcrumb>
          <div className="card-wrap-custome">
            <Questions2 saveQuestions={handleSaveQuestions} patientData={patientData}></Questions2>
          </div>
        </>
      )}
    </>
  )
}
